import React from 'react';
import {
	ApSecondaryNav,
	ApButtonTab,
	ApMenu,
	ApMenuItem,
	colors,
} from '@alixpartners/ui-components';
import { NavLink, useLocation } from 'react-router-dom';
import { NAV_CONFIG } from 'SupplierDiversity/utils';

export const SecondaryNav = () => {
	const location = useLocation();
	return (
		<ApSecondaryNav
			left={NAV_CONFIG.map(tab => {
				if ('path' in tab) {
					const { label, path } = tab;
					return (
						<NavLink to={path} key={path}>
							<ApButtonTab isSelected={location.pathname.includes(path)}>
								{label}
							</ApButtonTab>
						</NavLink>
					);
				} else {
					return (
						<ApMenu
							toggleVariant="hover"
							button={
								<ApButtonTab
									isSelected={tab.child.some(
										child => child.path === location.pathname
									)}
								>
									{tab.label}
								</ApButtonTab>
							}
						>
							{tab.child.map(option => (
								<ApMenuItem
									key={option.value}
									style={{
										backgroundColor:
											option.path === location.pathname ? colors.green0 : null,
									}}
								>
									<NavLink
										to={option.path}
										key={option.path}
										disabled={option.disabled}
									>
										{option.label}
									</NavLink>
								</ApMenuItem>
							))}
						</ApMenu>
					);
				}
			})}
		/>
	);
};

export default SecondaryNav;
